import { render } from "./PortfolioTwoPage.vue?vue&type=template&id=1c38a7fe"
import script from "./PortfolioTwoPage.vue?vue&type=script&lang=js"
export * from "./PortfolioTwoPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__